import { uniq } from 'lodash';

export function decodeHTMLEncodedString(encodedStr) {
  const p = document.createElement('p');
  p.innerHTML = encodedStr;
  return p.childNodes[0].nodeValue;
}

export function convertCommaSeparatedStringToArray(value) {
  if (!value) {
    return [];
  }

  // Build a unique array of equipment objects
  const items = value
    .replace(/\n/g, ',')
    .split(',')
    .map((item) => (item || '').trim())
    .filter((item) => item.length > 0);

  return uniq(items);
}

export function isBase64String(string) {
  const base64regex =
    /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;
  return base64regex.test(string);
}
